<template>
  <div class="publicMain">
    <div class="mianbao">
      <!--  -->
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item >首页</el-breadcrumb-item>
        <el-breadcrumb-item>咨询管理</el-breadcrumb-item>
        <el-breadcrumb-item>咨询管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!-- 模糊查询 -->
    <div class="childrenFileSelect">
      <el-form :inline="true" :model="form" class="demo-form-inline">
        <el-form-item label="咨询名称">
          <el-input v-model="form.infoName"></el-input>
        </el-form-item>
        <el-form-item label="发布状态">
          <el-select v-model="form.state">
            <el-option label="未发布" :value="0"></el-option>
            <el-option label="已发布" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onCheck">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="onReset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 新增按钮 -->
    <!-- <div class="add">
      <el-button type="primary" @click="addDate" size="mini">新增</el-button>
    </div>-->
    <div class="add">
      <el-button type="primary" size="small" @click="add">新增</el-button>
      <el-button type="success" size="small" @click="addTypeManage">分类管理</el-button>
    </div>
    <!-- 表格 -->
    <div class="table">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column type="index" width="50" label="序号" header-align="center" align="center"></el-table-column>
        <el-table-column
          v-for="(item,index) in tableColumn"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          header-align="center"
          :width="item.type=='button'?300:''"
        >
          <template slot-scope="scope">
            <div v-if="item.type=='button'" style="width:300px;display: flex;justify-content: center;">
              <el-tooltip class="item" effect="light" content="发布" placement="top-start" v-if="scope.row.state==0">
                <button class="el-icon-s-promotion tabBtn" @click="out(scope.row)"></button>
              </el-tooltip>
              <el-tooltip class="item" effect="light" content="查看" placement="top-start">
                <button class="iconfont icon-chakan tabBtn" @click="check(scope.row)"></button>
              </el-tooltip>
              <el-tooltip class="item" effect="light" content="修改" placement="top-start" v-if="scope.row.state==0">
                <button class="iconfont icon-bianji3 tabBtn"  @click="compile(scope.row)"></button>
              </el-tooltip>
              <el-tooltip class="item" effect="light" content="删除" placement="top-start">
                <button class="iconfont icon-icon7 tabBtn" @click="remove(scope.row)"></button>
              </el-tooltip>
            </div>
            <div v-if="item.type=='state'">
              <div style="text-align:center">
                <el-tag v-if="scope.row[item.prop]==0" type="warning">未发布</el-tag>
                <el-tag v-if="scope.row[item.prop]==1" type="success">已发布</el-tag>
              </div>
            </div>
            <div
              v-else
              :style="{'text-align':item.align?item.align:'center'}"
            >{{scope.row[item.prop]}}</div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
    <!-- 弹窗 -->
    <el-dialog :title="title" :visible.sync="helpEnvAddShow" width="50%">
      <div class="slot">
        <consultManageAdd
          :buttonType="buttonType"
          :row="row"
          @cancel="cancel"
          v-if="helpEnvAddShow"
        />
      </div>
    </el-dialog>
    <!-- 弹窗 -->
    <el-dialog :title="title" :visible.sync="helpEnvAddTypeShow" width="50%">
      <div class="slot">
        <consultManageType
          :buttonType="buttonType"
          :row="row"
          @cancel="cancelType"
          v-if="helpEnvAddTypeShow"
        />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  ConsultList,
  ConsultDelete,
  ConsultEdit,
} from "./api";
import consultManageAdd from "./components/consultManageAdd.vue";
import consultManageType from "./components/consultManageType.vue";
export default {
  components: {
    consultManageAdd,
    consultManageType
  },
  data() {
    return {
      currentPage: 1, //默认展示第一页
      //模糊查询数据
      form: {
      },
      title: "", //el-dialog标题
      visible: false,
      //table表格的column
      tableColumn: [
        {
          prop: "infoName",
          label: "资讯名称"
        },
        {
          prop: "informationTypeName",
          label: "资讯类型"
        },
        {
          type:'state',
          prop: "state",
          label: "发布状态"
        },
        {
          prop: "updateDate",
          label: "发布日期"
        },

        {
          label: "操作",
          type: "button"
        }
      ],
      //table表格的数据
      tableData: [],
      buttonType: "", //按钮的类型
      row: {}, //点击当前按钮的row数据
      total: 0, //总数据
      pageNo: 1,
      pageSize: 10,
      helpEnvAddTypeShow: false,
      helpEnvAddShow: false
    };
  },
  methods: {
    //查询
    onCheck() {
      this.ConsultListAPI({
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        ...this.form
      });
      this.$message({
        message: "查询成功",
        type: "success"
      });
    },
    //重置
    onReset() {
      this.form = {};
      this.ConsultListAPI({
        pageNo: this.pageNo,
        pageSize: this.pageSize
      });
      this.$message({
        message: "重置成功",
        type: "success"
      });
    },
    //每页请求数据
    handleSizeChange(val) {
      this.pageSize = val;
      this.ConsultListAPI();
      this.$message({
        message: `每页请求${val}条数据成功`,
        type: "success"
      });
    },
    //请求第几数据
    handleCurrentChange(val) {
      this.pageNo = val;
      this.ConsultListAPI();
      this.$message({
        message: `请求第${val}页数据成功`,
        type: "success"
      });
    },
    //拿到的列表
    ConsultListAPI(e) {
      let params = Object.assign({}, e, {
        pageNo: this.pageNo,
        pageSize: this.pageSize
      });
      ConsultList(params).then(res => {
        this.tableData = res.content.list;
        this.total = res.content.count;
      });
    },
    //新增分类管理
    addTypeManage() {
      this.title = "新增分类管理";
      this.helpEnvAddTypeShow = true;
    },
    //新增
    add() {
      this.helpEnvAddShow = true;
      this.buttonType = "add";
      this.title = "新增";
    },
    //查看
    check(e) {
      this.buttonType = "check";
      this.row = e;
      this.helpEnvAddShow = true;
      this.title = "查看";
    },
    //编辑
    compile(e) {
      this.buttonType = "compile";
      this.row = e;
      this.helpEnvAddShow = true;
      this.title = "编辑";
    },
    //发布
    out(e) {
      this.$confirm("确认发布吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "success"
      })
        .then(() => {
          let params = Object.assign({},e,{
            state:1
          })
          ConsultEdit(params).then(res => {
            this.$message({
              type: "success",
              message: "发布成功!"
            });
            this.ConsultListAPI();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消发布"
          });
        });
    },
    //删除
    remove(e) {
      this.$confirm("确认永久删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error"
      })
        .then(() => {
          ConsultDelete({ id: e.id }).then(res => {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.ConsultListAPI();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    //新增弹窗取消按钮
    cancel() {
      this.helpEnvAddShow = false;
      this.ConsultListAPI()
    },
    //类型取消按钮
    cancelType() {
      this.helpEnvAddTypeShow = false;
    },
  },
  created() {
    this.ConsultListAPI({
      pageNo: 1,
      pageSize: 10
    });
  }
};
</script>

<style lang="less" scoped>
.publicMain {
  background-color: #fff;
  padding: 16px;
  box-sizing: border-box;
  width: 100%;
  height: 100%;

}
// 面包屑导航box
.mianbao {
  box-sizing: border-box;
  margin: -16px -16px 0;
  background-color: #eef1f6;
  height: 47px;
  align-items: center;
  padding-left: 16px;
  margin-bottom: 16px;
}
.childrenFileSelect {
  margin-top: 20px;
}
.table {
  margin: 20px 0px;
}
.add {
  margin: 20px 0px;
}
.slot {
  width: 90%;
  margin: auto;
}
.childrenFileSelect {
  border: 1px solid rgb(230, 230, 230);
  padding: 20px;
}
.icon-icon7 {
color: #dd3020;

}
.icon-tongguos {
  color: #0d5795
}
</style>
